import PopoutMenuItem from './PopoutMenuItem';

export default PopoutMenuItem;
